module.exports = __webpack_public_path__ + "static/media/ic_delete.81d26a72.svg";